/*
 * md-videos-clientes.js
 * Carrossel UGC: autoplay no card visivel, pause fora, toggle de som.
 * Bandeira: converte ISO 2 letras em emoji (regional indicator).
 * Garante que apenas um video com som toca ao mesmo tempo.
 */

(function () {
  'use strict';

  var SEL_CARD = '[data-md-vc-card]';
  var SEL_VIDEO = '[data-md-vc-video]';
  var SEL_SOM = '[data-md-vc-som]';
  var SEL_BANDEIRA = '[data-md-vc-bandeira]';

  function qsa(sel, root) {
    return (root || document).querySelectorAll(sel);
  }

  function paisParaEmoji(iso) {
    if (!iso || iso.length !== 2) return '';
    var a = iso.charCodeAt(0);
    var b = iso.charCodeAt(1);
    if (a < 65 || a > 90 || b < 65 || b > 90) return '';
    try {
      return String.fromCodePoint(0x1f1e6 + (a - 65), 0x1f1e6 + (b - 65));
    } catch (e) {
      return '';
    }
  }

  function pausarComSomExceto(exceto) {
    var vids = qsa(SEL_VIDEO);
    for (var i = 0; i < vids.length; i++) {
      if (vids[i] !== exceto && vids[i].muted === false) {
        vids[i].muted = true;
        var btn = vids[i]
          .closest(SEL_CARD)
          .querySelector(SEL_SOM);
        if (btn) btn.setAttribute('aria-pressed', 'false');
      }
    }
  }

  function initCard(card) {
    if (card.dataset.mdVcInit === '1') return;
    card.dataset.mdVcInit = '1';

    var video = card.querySelector(SEL_VIDEO);
    var btn = card.querySelector(SEL_SOM);
    var bandeira = card.querySelector(SEL_BANDEIRA);

    if (bandeira) {
      var iso = (card.getAttribute('data-md-vc-pais') || '')
        .toUpperCase()
        .trim();
      var emoji = paisParaEmoji(iso);
      bandeira.textContent = emoji || iso;
    }

    if (btn && video) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (video.muted === false) {
          video.muted = true;
          btn.setAttribute('aria-pressed', 'false');
        } else {
          pausarComSomExceto(video);
          video.muted = false;
          btn.setAttribute('aria-pressed', 'true');
          try {
            var p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () {});
            }
          } catch (e) {}
        }
      });
    }

    if (!video) return;

    if (typeof window.IntersectionObserver === 'function') {
      var io = new window.IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var e = entries[i];
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              try {
                var p = video.play();
                if (p && typeof p.catch === 'function') {
                  p.catch(function () {});
                }
              } catch (err) {}
            } else {
              try {
                video.pause();
              } catch (err) {}
            }
          }
        },
        { threshold: [0, 0.6, 1] }
      );
      io.observe(card);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll(SEL_CARD);
    for (var i = 0; i < cards.length; i++) {
      initCard(cards[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      },
      { once: true }
    );
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    initAll(ev && ev.target ? ev.target : document);
  });

  document.addEventListener(
    'play',
    function (ev) {
      var t = ev.target;
      if (t && t.matches && t.matches(SEL_VIDEO) && t.muted === false) {
        pausarComSomExceto(t);
      }
    },
    true
  );
})();
